const degrees = [
  {
    school: 'Utrecht University',
    degree: 'Master of Science (M.Sc.)',
    link: 'https://www.uu.nl/en/organisation/methodology-and-statistics/master-msbbss',
    year: '2017 - 2019',
    highlights: [
      'Research Master in Methodology and Statistics for the Behavioural, Biomedical, and Social Sciences (final grade: 8.3, cum laude)',
      'Thesis topic: Automatic Transport Mode Prediction in a National Travel Survey',
      'Concurrently completed the EMOS Master',
      'Selected for the Utrecht University Honours Programme for graduate students',
    ],
  },
  {
    school: 'Yenching Academy of Peking University',
    degree: 'Master of Laws (LL.M.)',
    link: 'https://yenchingacademy.pku.edu.cn/',
    year: '2015 - 2017',
    highlights: [
      'Admitted as inaugural Yenching Scholar on a full scholarship (final grade: 91%)',
      'Thesis topic: Panda Diplomacy: China’s Foreign Policy through Panda Diplomacy',
      'Focused on contemporary Chinese domestic economic challenges and foreign policy (awarded Deans Research Grant)',
    ],
  },
  {
    school: 'Leiden University',
    degree: 'Bachelor of Science (B.Sc.)',
    link: 'https://www.universiteitleiden.nl/en/education/study-programmes/bachelor/political-science/international-relations-and-organisations',
    year: '2012 - 2015',
    highlights: [
      'Bachelor of Science in International Relations (final grade: 8.1, cum laude)',
      'Thesis topic: Contagious Democracy: The role of Trading Partners in the Democratization Process of Undemocratic Countries (9/10), nominated for the Van den Berg thesis of highest merit prize)',
      'Completed the Honours Academy Faculty of Social Sciences for undergraduate students',
      'Selected participant of the Netherlands Asia Honours Summer School (NAHSS), I received a scholarship to complete a summer school at Fudan University, Shanghai, where I conducted research for the Dutch Ministry of Foreign Affairs on the Belt and Road initiative',
      'Recipient of Lustra+ Scholarship for a semester exchange programme at McGill University (Montréal, Canada)',
    ],
  },
];

export default degrees;
